<template>
    <div class="spinner-container">
        <div class="submit_spinner">
            <svg class="spinner" v-show="isLoading" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
            </svg>
            <svg class="spinner" v-show="isSuccess" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
            </svg>
            <svg class="suc" v-show="isSuccess">
                <path class="checkmark__check" fill="none" d="M10.7,20.4l5.3,9.3l13.4-15.5"></path>
            </svg>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'submit-spinner',
        props: {
            isLoading: Boolean,
            isSuccess: Boolean
        }
    }
</script>
<style>
    .spinner-container {
        position: absolute;
        z-index: 2;
        background-color: #ffffffab;
        width: 100%;
        height: 100%;
        padding: 19% 0;
    }
    .submit_spinner {
        position: relative;
        height: 70px;
        width: 100%;
    }
    .spinner{
        -webkit-animation: rotator 1.4s linear infinite;
        animation: rotator 1.4s linear infinite;
    }
    @-webkit-keyframes rotator {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(270deg);
            transform: rotate(270deg);
        }
    }

    @keyframes rotator {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(270deg);
            transform: rotate(270deg);
        }
    }
    .path {
        stroke-dasharray: 187;
        stroke-dashoffset: 0;
        -webkit-transform-origin: center;
        transform-origin: center;
        -webkit-animation: dash 1.4s ease-in-out infinite, colors 5.6s ease-in-out infinite;
        animation: dash 1.4s ease-in-out infinite, colors 5.6s ease-in-out infinite;
    }

    @-webkit-keyframes colors {
        0% {
            stroke: #4285F4;
        }
        25% {
            stroke: #DE3E35;
        }
        50% {
            stroke: #F7C223;
        }
        75% {
            stroke: #1B9A59;
        }
        100% {
            stroke: #4285F4;
        }
    }

    @keyframes colors {
        0% {
            stroke: #4285F4;
        }
        25% {
            stroke: #DE3E35;
        }
        50% {
            stroke: #F7C223;
        }
        75% {
            stroke: #1B9A59;
        }
        100% {
            stroke: #4285F4;
        }
    }
    @-webkit-keyframes dash {
        0% {
            stroke-dashoffset: 187;
        }
        50% {
            stroke-dashoffset: 46.75;
            -webkit-transform: rotate(135deg);
            transform: rotate(135deg);
        }
        100% {
            stroke-dashoffset: 187;
            -webkit-transform: rotate(450deg);
            transform: rotate(450deg);
        }
    }
    @keyframes dash {
        0% {
            stroke-dashoffset: 187;
        }
        50% {
            stroke-dashoffset: 46.75;
            -webkit-transform: rotate(135deg);
            transform: rotate(135deg);
        }
        100% {
            stroke-dashoffset: 187;
            -webkit-transform: rotate(450deg);
            transform: rotate(450deg);
        }
    }
    .checkmark__check {
        transform-origin: 50% 50%;
        stroke-dasharray: 48;
        stroke-dashoffset: 48;

        animation: stroke 0.5s cubic-bezier(0.65, 0, 0.45, 1) 1.5s forwards,
        color 6s linear infinite;
    }
    @keyframes stroke {
        100% {
            stroke-dashoffset: 0;
        }
    }
    .suc {
        stroke: #149045;
        stroke-width: 5px;
        position: absolute;
        top: 10px;
        left: 0;
        height: 40px;
        right: 0;
        margin-right: auto;
        margin-left: auto;
        width: 40px;
    }
    .submit_spinner svg{
        margin: auto;
    }


</style>


// WEBPACK FOOTER //
// resources/assets/js/front/components/submit_spinner.vue